import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-preview"
export default class extends Controller {
  static values = {
    fileType: String,
    fileUrl: String,
    fileName: String
  }
  
  connect() {
    // File preview controller connected
  }
  
  expand(event) {
    // Check if we're on a small screen (mobile/tablet)
    if (window.innerWidth < 768) {
      // On small screens, don't show preview modal
      // Allow default behavior (like download links to work)
      return
    }
    
    event.preventDefault()
    
    const fileUrl = this.fileUrlValue
    const fileType = this.fileTypeValue
    const fileName = this.fileNameValue
    
    if (!fileUrl) {
      return
    }
    
    // Create modal with preview
    const modal = document.createElement('div')
    modal.classList.add('file-preview-modal')
    
    let previewContent
    if (fileType === 'image') {
      previewContent = `<img src="${fileUrl}" class="max-h-[80vh] max-w-full object-contain">`
    } else if (fileType === 'pdf') {
      previewContent = `
        <iframe src="${fileUrl}#view=FitH" 
                class="w-full h-[80vh] border-0">
        </iframe>
      `
    } else {
      previewContent = `
        <div class="text-center p-8">
          <p class="text-lg font-medium">Preview not available</p>
          <a href="${fileUrl}" download class="mt-4 inline-block px-4 py-2 bg-indigo-600 text-white rounded">
            Download file
          </a>
        </div>
      `
    }
    
    modal.innerHTML = `
      <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div class="bg-white rounded-lg shadow-xl max-w-5xl w-full max-h-[90vh] flex flex-col">
          <div class="p-4 border-b flex justify-between items-center">
            <h3 class="font-medium">${fileName || 'File Preview'}</h3>
            <button type="button" class="text-gray-400 hover:text-gray-500" data-action="click->file-preview#closeModal">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
          <div class="overflow-auto p-4 flex-grow">
            ${previewContent}
          </div>
        </div>
      </div>
    `
    
    document.body.appendChild(modal)
    document.body.classList.add('overflow-hidden')
    
    // Find the close button and attach event
    modal.querySelector('[data-action="click->file-preview#closeModal"]').addEventListener('click', () => {
      this.closeModal()
    })
    
    // Also close when clicking outside
    modal.querySelector('.fixed').addEventListener('click', (e) => {
      if (e.target === modal.querySelector('.fixed')) {
        this.closeModal()
      }
    })
  }
  
  closeModal() {
    const modal = document.querySelector('.file-preview-modal')
    if (modal) {
      document.body.removeChild(modal)
      document.body.classList.remove('overflow-hidden')
    }
  }
} 
 